module.exports = __webpack_public_path__ + "static/img/framework.bc8c75d8.png";